module.exports = __webpack_public_path__ + "img/vip.b02494b9.png";